var render, staticRenderFns
import script from "./MonthIncomeYearlyChart.vue?vue&type=script&lang=js&"
export * from "./MonthIncomeYearlyChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec54c54c",
  null
  
)

export default component.exports